var _g;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
var SvgFadPaste = function SvgFadPaste(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    viewBox: "0 0 256 256",
    xmlns: "http://www.w3.org/2000/svg"
  }, props), _g || (_g = /*#__PURE__*/React.createElement("g", {
    fill: "none",
    fillRule: "evenodd"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M47.174 74.383c0-9.94 8.067-17.87 17.997-17.712l21.398.34s4.011-10.206 17.826-10.206c13.814 0 16.6 9.58 16.6 9.58h23.35c8.841 0 16.066 7.169 16.137 16.007l.123 15.5 11.998-.08c2.206-.015 5.354 1.143 7.02 2.577l27.06 23.28c1.671 1.439 3.026 4.403 3.026 6.608v85.158a3.984 3.984 0 0 1-4.005 3.985l-106.865-.5a4.98 4.98 0 0 1-4.953-5.025l.247-27.695-30.963.195A15.87 15.87 0 0 1 47.174 160.5V74.383z",
    fill: "#000"
  }), /*#__PURE__*/React.createElement("ellipse", {
    fill: "#FFF",
    cx: 104,
    cy: 65,
    rx: 8,
    ry: 7
  }), /*#__PURE__*/React.createElement("path", {
    d: "M64.378 74.883a2.067 2.067 0 0 1 1.972-2.08l20.544-.841s4.63 11.101 17.133 11.101c12.504 0 17.418-10.667 17.418-10.667l20.593.477a2.042 2.042 0 0 1 1.985 2.051l-.12 11.57a1.975 1.975 0 0 1-2.013 1.966l-32.069-.64a15.692 15.692 0 0 0-16.06 15.679l-.23 53.884a2.043 2.043 0 0 1-2.016 2.023l-23.907.298a2.004 2.004 0 0 1-2.037-1.973l-1.193-82.848zm107.672 33.413c-1.675-1.437-2.944-.822-2.834 1.401l.727 14.677c.11 2.21 1.986 4.01 4.198 4.017l17.418.062c2.209.008 2.647-1.146.968-2.587l-20.478-17.57z",
    fill: "#FFF"
  }), /*#__PURE__*/React.createElement("path", {
    d: "m112.078 104.88-.325 88.576 80.378.57V144.46h-32.189c-4.418 0-8.019-3.575-8.041-8.007l-.167-32.275-39.656.704z",
    stroke: "#979797",
    fill: "#FFF"
  }))));
};
export { SvgFadPaste as ReactComponent };
export default __webpack_public_path__ + "static/media/fad-paste.fb8ddcf1.svg";